import { showNotification } from 'SourceStore/Notification/Notification.action';
import { QueryDispatcher } from 'SourceUtil/Request';
import { addRelatedProducts, updateLoadStatus } from './RelatedProducts.action';
import AutoRelatedProducts from '../../query/AutoRelatedProducts.query';    
/**
 * RelatedProducts Dispatcher
 * @class RelatedProductsDispatcher
 * @extends QueryDispatcher
 * @namespace Store/RelatedProducts/Dispatcher
 */
export class RelatedProductsDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('relatedProducts');
    }
    onSuccess({ amMostviewedGroups }, dispatch) {
        const { items = {} } = amMostviewedGroups;
        this.dispatchRelatedProducts(dispatch, items);
    }

    dispatchRelatedProducts ( dispatch, items ) {
        dispatch(addRelatedProducts(items));
        dispatch(updateLoadStatus(false));
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching Related Products Information!'), error));
    }

    /**
     * Prepare relatedProducts query
     * @return {Query} RelatedProducts query
     * @memberof relatedProductsProductsDispatcher
     * @param relatedProducts
     */
    prepareRequest({productId, position}, dispatch) {
        
        dispatch(updateLoadStatus(true));
        return [
            AutoRelatedProducts.getQuery(productId, position)
        ];
    }
}

export default new RelatedProductsDispatcher();